import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path d="M16 4l-3 9H4l7 5.5L8 28l8-6 8 6-3-9.5 7-5.5h-9z" fill="none" />
  </Icon>
);
